/**
 * ОДНА СТРОКА под кнопкой выбора картинки — видимая диагностика вместо
 * консоли.
 *
 * Зачем: Антон 2026-09-24 не может открыть инструменты разработчика
 * (Cmd+Option+I в его оболочке не работает), а жалоба звучит как
 * «кнопку вижу, но она не нажимается» — то есть всё молчит. Пока
 * происходящее не сказано человеку словами, причину нельзя ни
 * подтвердить, ни опровергнуть.
 *
 * Сознательно СКРОМНО: одна строка, мелкий шрифт, гаснет сама через
 * несколько секунд (таймер живёт в useImagePicker). Не панель, не лог,
 * не простыня — иначе интерфейс превратится в отладчик.
 */
import { color, font, space } from "./theme";
import type { PickerNote } from "./useImagePicker";

export function PickerNoteLine({
  note,
  testId,
}: {
  note: PickerNote | null;
  testId: string;
}) {
  if (!note) return null;
  return (
    <div
      data-testid={testId}
      /* Ошибку объявляем сразу (alert), обычный ход событий — вежливо
         (status), чтобы экранный диктор не перебивал сам себя. */
      role={note.kind === "error" ? "alert" : "status"}
      style={{
        marginTop: space.sm,
        fontSize: font.small,
        lineHeight: 1.35,
        color: note.kind === "error" ? color.danger : color.textDim,
        /* Длинное имя файла не должно распирать раскладку. */
        overflowWrap: "anywhere",
      }}
    >
      {note.text}
    </div>
  );
}
